import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import { IStylesProps } from "./PreferredCondition";

//TODO create a separate ‘modifier’ class and use it instead of bunch of if
// statements and styles adapting
export default makeStyles<MuiTheme, IStylesProps>((theme: MuiTheme) => ({
  paper: {
    position: "relative",
    minHeight: 50,
    padding: "9px 9px 0",
    "&.emptyPreferredConditions": {
      padding: 9,
      display: "flex"
    }
  },
  mainInfo: {
    display: "flex"
  },
  grid: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    flex: "auto"
  },
  placeholder: {
    fontSize: 14,
    lineHeight: "normal",
    color: theme.palette.text.hint,
    paddingLeft: 8
  },
  gridItem: {
    display: "flex",
    flexDirection: "column",
    marginBottom: 4
  },
  emptyGridItem: {
    margin: 0
  },
  gridItemNote: {
    "& $gridItemTitle": {
      paddingBottom: 3
    },
    [theme.breakpoints.up("lg")]: {
      alignItems: "baseline",
      flexDirection: "column"
    }
  },
  gridItemTitle: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 14,
    padding: "6px 8px",
    lineHeight: 1,
    minWidth: 88,
    [theme.breakpoints.down("md")]: {
      paddingBottom: 3
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: 16
    }
  },
  gridItemContent: {
    display: "flex",
    flexWrap: "wrap",
    padding: "6px 8px 1px 8px"
  },
  snack: {
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 12,
    height: 22,
    lineHeight: 1,
    color: ({ isLastRace }) => (isLastRace ? "#48769b" : "#2d2d2d"),
    border: ({ isLastRace }) =>
      `1px solid ${isLastRace ? "#48769b" : theme.palette.primary.light}`,
    backgroundColor: ({ isLastRace }) => {
      return isLastRace ? "rgba(72, 118, 155, 0.1)" : "rgba(238, 238, 238, 1)";
    },
    fontWeight: ({ isLastRace }) => isLastRace && 600,
    padding: "0 4px",
    marginRight: 5,
    marginBottom: 5,
    borderRadius: 2
  },
  wide: {
    padding: "0 16px"
  },
  note: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    wordBreak: "break-word",
    paddingTop: 3
  },
  buttonWrapper: {
    padding: 8
  },
  editButton: {
    position: "absolute",
    right: 16,
    top: 13,
    width: 70,
    height: 24,
    fontSize: 12,
    color: theme.palette.text.secondary,
    display: "flex",
    alignItems: "center",
    padding: "3px 0",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 2
  },
  editIcon: {
    fontSize: 14,
    marginRight: 4,
    marginTop: -1
  }
}));
